"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccommodationPreferencesSaveDto {
}
exports.AccommodationPreferencesSaveDto = AccommodationPreferencesSaveDto;
